export const users = [
  {
    id: "usr_001",
    name: "Leena Shah",
    status: "pending",
    email: "leena.shah@example.com",
    phone: "+923001234567",
    createdAt: new Date("2025-05-15T10:30:00Z"),
  },
  {
    id: "usr_002",
    name: "Omar Farooq",
    status: "processing",
    email: "omar.farooq@example.com",
    phone: "+923004567890",
    createdAt: new Date("2025-05-16T09:15:00Z"),
  },
  {
    id: "usr_003",
    name: "Hira Ansari",
    status: "success",
    email: "hira.ansari@example.com",
    phone: "+923008765432",
    createdAt: new Date("2025-05-17T14:50:00Z"),
  },
  {
    id: "usr_004",
    name: "Zain Raza",
    status: "failed",
    email: "zain.raza@example.com",
    phone: "+923007654321",
    createdAt: new Date("2025-05-18T12:00:00Z"),
  },
  {
    id: "usr_005",
    name: "Nida Kazmi",
    status: "success",
    email: "nida.kazmi@example.com",
    phone: "+923002345678",
    createdAt: new Date("2025-05-19T08:45:00Z"),
  },
];

export const notificatios = [
  {
    title: "Reminder",
    type: "In-App",
    status: "Failed",
    createdAt: new Date(),
  },
  {
    title: "Reminder",
    type: "In-App",
    status: "Sent",
    createdAt: new Date(),
  },
  {
    title: "Reminder",
    type: "In-App",
    status: "Sent",
    createdAt: new Date(),
  },
  {
    title: "Reminder",
    type: "In-App",
    status: "Failed",
    createdAt: new Date(),
  },
  {
    title: "Reminder",
    type: "In-App",
    status: "Failed",
    createdAt: new Date(),
  },
];

export const products = [
  {
    title: "Industrial Safety Helmet",
    category: "Head Protection",
    status: "Published",
    createdAt: new Date("2024-11-01"),
  },
  {
    title: "Reflective Traffic Cone",
    category: "Road Safety",
    status: "Low Stock",
    createdAt: new Date("2024-10-15"),
  },
  {
    title: "Dust Mask N95",
    category: "Face Protection",
    status: "Out of Stock",
    createdAt: new Date("2024-09-22"),
  },
  {
    title: "LED Baton Light",
    category: "Traffic Control",
    status: "Published",
    createdAt: new Date("2024-12-05"),
  },
  {
    title: "Chain Block 2 Ton",
    category: "Lifting Equipment",
    status: "Low Stock",
    createdAt: new Date("2025-01-10"),
  },
  {
    title: "Allen Bolt Set M10",
    category: "Fasteners",
    status: "Published",
    createdAt: new Date("2025-02-18"),
  },
  {
    title: "Fire Safety Signage",
    category: "Safety Accessories",
    status: "Out of Stock",
    createdAt: new Date("2025-03-01"),
  },
  {
    title: "PVC Traffic Barrier",
    category: "Road Safety",
    status: "Published",
    createdAt: new Date("2024-12-22"),
  },
];

// Email-based access configuration for sidebar/menu visibility
export type EmailAccessRule = {
  // Top-level menu ids from src/lib/routes.tsx (e.g., "notifications", "feed", "products")
  allowedMenuIds: string[];
  // Default path to redirect the user to when logging in or navigating outside their allowed scope
  defaultPath: string;
};

// Make this configurable: add/remove entries or change defaults without touching component logic
export const EMAIL_ACCESS_RULES: Record<string, EmailAccessRule> = {
  "notification@qjskills.com": {
    allowedMenuIds: ["notifications"],
    defaultPath: "/dashboard/notifications/manage-notification",
  },
  "feeds@qjskills.com": {
    allowedMenuIds: ["feed"],
    defaultPath: "/dashboard/feed/manage-post",
  },
};
